import React, {Component} from 'react';

import APIClient from './Api';
import { getImageUrl } from './ImageUtils';

const client = new APIClient();


class ScreenTransition extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null
    };
  }

  componentDidMount() {
    client.getHomeTestimonials().then((data) => {
      this.setState({data: data});
    });
  }

  render() {
    if (this.state.data !== null) {
      return (
        <div id="Screen_transition">
          <div class="gp-content1">
            <div class="gp-title text-uppercase">
              Comme vous, Axel, {this.state.data[0].title}, {this.state.data[1].title} et {this.state.data[2].title} ont témoigné
            </div>
            <div class="gp-video-container">
              <iframe
                src="https://www.youtube.com/embed/9nydvxVKTSM?wmode=opaque"
                allowFullScreen={true}
                title="video"
              ></iframe>
            </div>
          </div>
          <div>
            <div class="gp-content1">
              <div class="gp-liste-temoignage">
                {
                this.state.data.map((testimonialData) =>
                  <div class="gp-temoignage">
                    <div class="gp-temoignage-img"><img src={getImageUrl(testimonialData.image)} alt="" /></div>
                    <p class="gp-titre-temoignage">{testimonialData.title}</p>
                    <p>“{testimonialData.message}”</p>
                  </div>
                )
                }
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return ''
    }
  }
}


export default ScreenTransition;
